import React from 'react'
import PropTypes from 'prop-types'
import useKeyboardShortcuts from '../use-keyboard-shortcuts'

export default function useEscHandler({ handler, enabled }) {
  useKeyboardShortcuts({
    handlers: {
      Escape: {
        action: handler,
      },
    },
    enabled,
  })
}

// This is just a dummy component so that we can use propTypes to make things easier to document
export const HookParameters = (props) => <div {...props} />

HookParameters.propTypes = {
  /** Callback ran as part of the returned escape handler function. */
  handler: PropTypes.func,
}
